import React, { useEffect, useState } from 'react';
import Header from 'pages/Header/HeaderNavegacion';
import BarraCP from 'components/BarCP/BarHeaderCP';
import { decodeStorage } from 'functions/storageBase64';
import Footer from 'pages/Footer/FooterDesktop';
import { MenuPoliticas } from 'components/MenuAutocenter/menuAutocenter';
import "./style.sass";
import { useHistory } from 'react-router-dom';
import { useIsMobile } from 'hooks/useIsMobile';

const title = "AVISO DE PRIVACIDAD CLIENTE INTEGRAL SEARS";

const TextDataPrivacidad = () => {

    return (
       <div className="contentTextData">
            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Quién dará tratamiento a sus datos personales?</h2>
                    <p>GS Tiendas Departamentales, S. A. de C. V., (en adelante Sears) con domicilio en Lago Zúrich No. 245, Edificio Presa Falcón piso 7, colonia Ampliación Granada, alcaldía Miguel Hidalgo, C.P. 11529, Ciudad de México, será el responsable del tratamiento de sus datos personales. </p>
                    <p>Para cualquier duda relacionada con la protección de sus datos personales podrá contactar a nuestro Departamento de Protección de Datos de Sears a la dirección electrónica <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a> </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Qué información vamos a recabar?</h2>
                    <p>Sears para cumplir con las finalidades señaladas en el presente Aviso recabará y tratará datos personales de identificación, incluyendo su imagen personal que podrá ser registrada a través de vídeos y/o fotografías cuando ingresa a nuestras sucursales y/o sea participe de nuestros eventos, datos personales de contacto, datos fiscales, datos de ubicación, datos personales patrimoniales y/o financieros, datos demográficos, información generada con motivo de la prestación de nuestros servicios, así como sobre su participación en nuestros sorteos, concursos y promociones, información sobre su vehículo, e información que usted nos proporcione de manera voluntaria para la atención de quejas, reclamaciones o solicitudes de información. </p>
                    <p>Asimismo, le informamos que para efectos de lo señalado en el presente Aviso de Privacidad Sears dará tratamiento a datos personales de terceros en calidad de referencias personales, por lo que al proporcionar los datos personales de dichos terceros para que Sears les contacte por medios físicos y/o electrónicos usted reconoce haber recabado el consentimiento requerido en términos de la normatividad aplicable. </p>
                    <p>En caso de que usted nos contacte por redes sociales, podremos recabar los datos de su perfil público de redes sociales para darle atención a sus peticiones y/o solicitudes de información en relación con los productos que ofrecemos, podremos dar tratamiento a la información contenida en su perfil público de la red social de que se trate, así como al contenido de sus publicaciones. </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Recabamos datos sensibles?</h2>
                    <p>Le informamos que recolectamos y tratamos datos biométricos (huella dactilar y características de su rostro), los cuales son considerados datos personales sensibles. </p>
                    <p>Estos datos serán utilizados únicamente para verificar su identidad, con el fin de prestar nuestros servicios y realizar las operaciones que usted lleve a cabo con nosotros. </p>
                    <p>Asimismo, Sears verificará que los datos personales contenidos en la credencial para votar que usted presente, incluyendo sus datos biométricos, coincidan con los que obran en poder del Instituto Nacional Electoral (INE). </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>No tratamiento de datos personales de menores de edad</h2>
                    <p>Sears no recaba datos personales o información directamente de menores de edad. </p>
                    <p>En el supuesto de que se proporcionen datos relacionados con personas menores de edad asumiremos que la persona que los proporciona es el padre, madre y/o tutor legal, quien reconoce haber leído y aceptado el presente aviso de privacidad. </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>Tratamiento automatizado de datos sin decisión humana valorativa y actividades de perfilamiento</h2>
                    <p>Le informamos que para dar cumplimiento a las finalidades previstas en este Aviso de Privacidad Sears realizará tratamientos automatizado de datos personales como parte de un proceso de toma de decisiones sin intervención humana valorativa y técnicas de análisis masivo de datos para realizar actividades de perfilamiento a partir de sus hábitos de consumo, gustos e intereses, monitorear su comportamiento y ofrecerle una experiencia personalizada en relación con el uso de los servicios, así como para dar cumplimiento a algunas(s) de las finalidades(es) informadas en el presente Aviso de Privacidad. </p>
                    <p>Si usted no desea que sus datos personales sean utilizados mediante mecanismos o tecnologías automatizadas, puede oponerse a ese tratamiento en cualquier momento. </p>
                    <p>Para hacerlo, debe presentar una solicitud siguiendo el procedimiento indicado en la cláusula correspondiente de este aviso, sobre el ejercicio de sus derechos ARCO y/o la revocación del consentimiento. </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Para qué fines usamos su información?</h2>
                    <p>Sears tratará sus datos personales para las siguientes finalidades primarias y necesarias: </p>
                    <ul className="ulQuestionDisc">
                        <li>Creación y gestión de su cuenta de usuario; </li>
                        <li>Identificarle y contactarlo para dar seguimiento a la entrega de los productos adquiridos; </li>
                        <li>Verificar y confirmar su identidad; incluyendo realizar procesos de verificación mediante el uso de datos biométricos en cumplimiento a la normatividad aplicable; </li>
                        <li>Acreditar, validar y verificar su identidad. Lo anterior incluye la verificación de los datos contenidos en su Credencial para Votar y datos biométricos ante los registros del Instituto Nacional Electoral; </li>
                        <li>Atender y resolver sus dudas relacionadas con la adquisición de nuestros productos y/o servicios; </li>
                        <li>Atender las solicitudes de compra remitidas y procesar pagos; </li>
                        <li>Facilitar la localización, tramitación, suministro, distribución y entrega de los productos solicitados por usted; </li>
                        <li>Para dar cumplimiento a lo dispuesto por la Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita y demás normatividad aplicable; </li>
                        <li>Aclaraciones bancarias; </li>
                        <li>Realizar consultas, investigaciones y revisiones en relación a quejas o reclamaciones; </li>
                        <li>Dar cumplimiento a los requerimientos de autoridades competentes en los casos legalmente previstos; </li>
                        <li>Para las gestiones de facturación relacionadas con los productos adquiridos; </li>
                        <li>Llevar un histórico de sus compras; </li>
                        <li>Otorgamiento de créditos; </li>
                        <li>Realizar actividades de análisis de su comportamiento crediticio y emisión de calificaciones crediticias; </li>
                        <li>Monitorear su comportamiento crediticio; </li>
                        <li>Detectar y prevenir fraudes; </li>
                        <li>Brindarle los servicios de sastrería; </li>
                        <li>Para contactar a través de llamadas telefónicas, envío de comunicaciones a través de correos electrónicos, mensajes cortos y demás medios de comunicación físicos y/o electrónicos, servicios de mensajería instantánea (WhatsApp, Telegram, entre otros). </li>
                        <li>Para llevar a cabo actividades de contacto, cobranza y validación de información con los terceros designados como referencias personales. </li>
                        <li>Informarle sobre cambios o nuevos productos o servicios relacionados con los productos adquiridos; </li>
                        <li>Activación, cancelación y análisis del uso de su(s) tarjeta(s); </li>
                        <li>Acumulación de puntos a través de monederos electrónicos o similares; </li>
                        <li>Para alimentar la base de datos del buró de crédito; </li>
                        <li>Integrar listas sobre regalos de su preferencia para envío a domicilio o canje en sucursales; </li>
                        <li>Brindar servicio de asistencia técnica y/o reparación si el producto cuenta con garantía vigente; </li>
                        <li>Darle de alta como cliente preferido y enviarle comunicaciones personalizadas; </li>
                        <li>Identificarle como cliente de CÍRCULO PLUS; </li>
                        <li>Determinar la zona geográfica para ofrecer contenidos, promociones o beneficios correspondientes; </li>
                        <li>Para realizar la venta de productos a través de Marketplace; </li>
                        <li>Elaborar material informativo sobre actividades y divulgar contenidos publicados por usted en redes sociales referidos a Sears; </li>
                        <li>Darle de alta en programas de lealtad; </li>
                        <li>Identificarle como usuario de Auto Center y llevar registro de sus servicios contratados; </li>
                        <li>Registrarle como participante en rifas, sorteos, concursos, dinámicas y/o promociones; </li>
                        <li>Autorización del uso de datos, imágenes, videos y fotos en caso de resultar ganador para fines publicitarios; </li>
                        <li>Identificarlo como visitante y tratamiento de su imagen para publicidad de actividades, promociones y servicios; </li>
                        <li>Realizar actividades de monitoreo de calidad en los servicios o sobre su experiencia de compra; </li>
                        <li>Análisis de datos mediante tecnologías de analítica y/o inteligencia artificial; </li>
                        <li>Mantener la seguridad de redes y servicios de comunicaciones electrónicas y detectar fallos; </li>
                        <li>Elaborar y divulgar material informativo sobre las actividades de la empresa; </li>
                        <li>Garantizar la seguridad física de las instalaciones y personas; </li>
                        <li>Videovigilancia dentro de las instalaciones para su seguridad y la del personal; </li>
                        <li>Dar atención a sus solicitudes de información, quejas o reclamaciones; </li>
                        <li>Dar cumplimiento a las obligaciones derivadas de la relación jurídica con usted; </li>
                        <li>Dar cumplimiento a las políticas y procedimientos de carácter interno; </li>
                        <li>Uso de datos para ejercicio o defensa de derechos en procesos administrativos o judiciales; </li>
                        <li>Dar cumplimiento a obligaciones previstas en la normatividad aplicable y requerimientos de autoridades. </li>
                    </ul>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Qué otros usos podemos darle a su información?</h2>
                    <p>De manera adicional, si usted no se opone, Sears podrá mantener su información personal para las siguientes finalidades que no son necesarias: </p>
                    <ul className="ulQuestionDisc">
                        <li>Informarle del lanzamiento o cambios de nuevos productos, promociones y ofertas de Sears y Empresas del Grupo; </li>
                        <li>Posibles contactos posteriores para ofrecimiento de productos o servicios; </li>
                        <li>Compartir perfiles y hábitos de consumo con socios comerciales y Empresas del Grupo para fines publicitarios o valoración de servicios; </li>
                        <li>Enviar publicidad y comunicaciones con fines de mercadotecnia y tele-marketing; </li>
                        <li>Realizar estadísticas, encuestas o estudios sobre hábitos de mercado y calidad del servicio. </li>
                    </ul>
                    <p>En caso de que no desee que sus datos sean tratados para estas finalidades, puede comunicarlo al correo <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a> </p>
                    <p>Asimismo, puede cancelar el envío de mensajes promocionales mediante el enlace "Cancelar Suscripción" en los correos enviados. </p>
                    <p>La negativa para estos usos adicionales no será motivo para negarle los servicios solicitados. </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿A qué terceros podemos transferir su información?</h2>
                    <p>Sears transferirá sin requerir de su consentimiento los datos necesarios a autoridades administrativas y judiciales, así como a terceros nacionales o extranjeros intervinientes en la prestación de servicios y formas de pago. </p>
                    <p>También podrá transferir datos a autoridades competentes, empresas subsidiarias, afiliadas o bajo control común, al Instituto Nacional Electoral y terceros con acuerdos jurídicos para validación de identidad. </p>
                    <p>La lista de empresas del grupo puede consultarse en su portal corporativo. </p>
                    <p>Se podrá entregar información a autoridades fiscales para cumplir con la Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita. </p>
                    <p>Sears transferirá datos sin consentimiento a socios comerciales y terceros para servicios de entrega, postventa, gestión de cuentas, programas de lealtad y comunicaciones de marketing. </p>
                    <p>En caso de incumplimiento de pago, los datos podrán transferirse a Sociedades de Información Crediticia por obligación legal. </p>
                    <p>Si no se opone, Sears podrá transferir datos a socios comerciales para ofrecimiento de bienes y servicios o valoración de sujetos de crédito. </p>
                    <p>Además, podrá compartir datos con autoridades de distintos niveles de gobierno como prueba en procedimientos judiciales o administrativos. </p>
                    <p>Para oponerse a transferencias que requieren consentimiento, envíe un correo a <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a> </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo puede ejercer sus derechos ARCO y/o revocar su consentimiento?</h2>
                    <p>Usted o su representante legal podrá ejercer los derechos de acceso, rectificación, cancelación u oposición, así como revocar su consentimiento enviando un correo a <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a> </p>
                    <p>Debe utilizar el Formato de Solicitud de Derechos ARCO solicitado a la misma dirección y acompañarlo con copia de una identificación oficial vigente. </p>
                    <p>Si la información es insuficiente, se le requerirán elementos adicionales en un plazo de cinco días hábiles; usted tendrá diez días para atender el requerimiento.</p>
                    <p>La determinación se comunicará en un plazo máximo de veinte días hábiles, haciéndose efectiva en los quince días siguientes si resulta procedente. </p>
                    <p>A través de este procedimiento también puede oponerse al tratamiento automatizado de sus datos personales. </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo puede limitar el uso y/o divulgación de sus datos?</h2>
                    <p>Podrá limitar el uso o divulgación enviando su solicitud a <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a> para ser registrado en el listado de exclusión propio de Sears. </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>Uso de cookies y web beacons</h2>
                    <p>Sears utiliza cookies y otras tecnologías para recordar preferencias, analizar el rendimiento y mostrar publicidad relevante.</p>
                    <p>Las cookies esenciales no pueden ser deshabilitadas ya que permiten el uso adecuado del sitio. </p>
                    <p>Usted puede deshabilitar el resto de las cookies a través de la configuración de su navegador (Internet Explorer, Firefox, Chrome, Safari, Edge).</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo le notificaremos de los cambios que efectuemos al presente Aviso de Privacidad?</h2>
                    <p>Cualquier cambio se notificará a través de la página de internet <a href="http://www.sears.com.mx" target="_blank" rel="noopener noreferrer">http://www.sears.com.mx</a> </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo puede hacernos llegar sus dudas?</h2>
                    <p>El Departamento de Protección de Datos está disponible en el correo <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a> </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo protegemos sus transacciones?</h2>
                    <p>Utilizamos el protocolo SSL (Secure Socket Layer) para transmitir información encriptada. Verifique el uso de "httpS" en su navegador. </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>Recomendaciones de seguridad</h2>
                    <p>Se recomienda elegir contraseñas únicas y no compartirlas con terceros. </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>Autoridad de Protección de Datos Personales (UPDP-SABG)</h2>
                    <p>Tiene el derecho de acudir ante la Unidad de Protección de Datos Personales de la Secretaría Anticorrupción y Buen Gobierno (SABG). </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>Aceptación de Aviso de Privacidad</h2>
                    <p>Al usar los servicios y proporcionar datos, usted acepta los términos de este Aviso de Privacidad. </p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <p><span className='bold'>Fecha de última actualización:</span> enero 2026 </p>
                </div>
            </div>
        </div>
    )
}


export function AvisoPrivacidadDesktop() {
    const codigoP = decodeStorage('codigoPostal');
    const [codigoPostal, setCodigoPsotal] = useState(codigoP);

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Aviso de Privacidad Clientes Page');
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        //setLoading(false)
    }, [codigoPostal])

    //recibe la direccion del CP
    const [updateCPBar, setUpdateCPBar] = useState();
    const changeDirectionBar = (val) => {
        setCodigoPsotal(val);
        setUpdateCPBar(val);
    };
    const [upCP, setUpCP] = useState();
    useEffect(() => {
        if (upCP) {
            //console.log('')
        }
    }, [upCP, updateCPBar])

    return (
        <>
            <Header setUpCP={setUpCP} changeDirectionBar={changeDirectionBar} />
            <section className="barCpResponsive">
                <BarraCP changeCP={changeDirectionBar} clase="barHeaderCP" />
            </section>

            <main>
                <section className="sectionAuto">
                    <div className="sectionMenu">
                        <MenuPoliticas />
                    </div>

                    <div className="sectionContent">
                        <section className="sectionTitleAuto">
                            <div className="divTitle">
                                <p>{title}</p>
                            </div>
                        </section>

                        <TextDataPrivacidad />

                    </div>
                </section>
            </main>

            <Footer />

        </>
    )
}

export function AvisoPrivacidadMobile() {
    const history = useHistory();
    const isNativeApp = window.location.search.indexOf('isNativeApp=true')
    // cerrar modal
    const onClose = () => {
        // history.goBack(-1);
        window.location.href = "/menu-mas"
    }

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Aviso de Privacidad Clientes Page');
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            <div className="modalDetallePedido full">
                <div className="contentModal">
                    {isNativeApp < 0
                        ?
                            
                            <div className="contentCloseAN">
                                <div className="btn closeBack" onClick={onClose} ></div>
                                <p className="title">{title}</p>
                            </div>
                        : null 
                    }
                    <TextDataPrivacidad />

                </div>
            </div>
        </>
    )
}

export function AvisoPrivacidad() {
    const { isMobile } = useIsMobile();

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Aviso de Privacidad Clientes');
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            {isMobile &&
                isMobile === 'desktop'
                ? <AvisoPrivacidadDesktop />

                : isMobile === 'movile'
                    ? null
                    : <AvisoPrivacidadMobile />
            }
        </>
    )
}